import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useParams, Link, useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';
import * as bookingsSelectors from 'selectors/bookings';
import * as actions from 'actions';
import Errors from 'components/shared/Errors';
import Success from 'components/shared/Success';
import Main from 'components/templates/Main';
import { setExpirationDateTime } from 'logic/bookingForm';
import CircularProgress from 'components/shared/CircularProgress';
import PATHS from 'constants/paths';
import EditForm from '../components/EditForm';

const BookingEdit = () => {
  const { bookingId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const booking = useSelector(bookingsSelectors.singleBooking);
  const isFetching = useSelector(bookingsSelectors.isFetching);
  const errors = useSelector(bookingsSelectors.error);
  const success = useSelector(bookingsSelectors.success);

  React.useEffect(() => {
    if (!isFetching) {
      dispatch(actions.fetchBookingRequest({ bookingId }));
    }
  }, []);

  React.useEffect(() => {
    if (success) {
      return history.push(
        PATHS.conversations.booking
          .replace(':conversationId', booking?.conversation_id)
          .replace(':bookingId', bookingId),
      );
    }
  }, [success]);

  const onSubmit = ({ booking_expiration_date }) => {
    dispatch(
      actions.putBookingRequest({
        bookingId,
        values: {
          booking_expiration_date: setExpirationDateTime(booking_expiration_date),
        },
      }),
    );
  };

  return (
    <Main
      title={
        <Button
          color="inherit"
          component={Link}
          to={PATHS.conversations.booking
            .replace(':conversationId', booking?.conversation_id)
            .replace(':bookingId', bookingId)}
        >
          <ArrowBack /> &nbsp;{' '}
          <FormattedMessage id="editBooking.heading" defaultMessage="Modify booking" /> #
          {booking?.id}
        </Button>
      }
    >
      {isFetching && <CircularProgress />}
      {!isFetching && booking && <EditForm booking={booking} onSubmit={onSubmit} />}

      <Success success={success} />
      <Errors errors={errors} />
    </Main>
  );
};

export default BookingEdit;
